<template>
  <div
    class="repcells"
    :class="[{ repcells_grid: flopGroup === 'swv_turns' }, `repcells_${flopGroup}`]"
  >
    <div
      v-for="item in items"
      :key="item.id"
      class="repcells_cell"
      :class="[
        { repcells_cell_active: item.id === reportItemId },
        { repcells_cell_empty: item.isEmpty },
      ]"
      @mouseenter="
        () => {
          if (item.isEmpty) return
          if (!reportItemId) {
            $store.commit('reports_set', { key: 'reportItem', value: item })
          }
        }
      "
      @click="
        () => {
          if (item.isEmpty) return
          $store.commit('reports_set', { key: 'reportItem', value: item })
          $store.commit('reports_set', {
            key: 'reportItem_id',
            value: item.id === reportItemId ? null : item.id,
          })
        }
      "
    >
      <div class="repcells_cell_item">
        <!-- :class="{ htc_hoverable: item.id !== reportItemId }" -->
        <HandTableCell
          v-for="(htcItem, index) in htcItems"
          :key="htcItem.key"
          v-bind="htcItem.props"
          :hasTitle="index === 0"
          :hasLegend="item.id === reportItemId && htcItem.key === 'strategy'"
          class="flex-1 repcells_cell_item_cell"
          style="--value-size: var(--htc-value-size); --value-padding: 0 0.325rem"
          rangeKey="htc_range"
          :valueKeys="['eq', 'eqr', 'ev']"
          :gameformat="gameformat"
          :comboPlayer="item[htcItem.props.player]"
          :hasPremiumGameformat="hasPremiumGameformat"
          :combo="item"
          :showBetsIn="showBetsIn"
          :showProp="viewProps.colValue.key"
          :isPreflop="isPreflop"
          :grouping="grouping"
          :viewProps="viewProps"
          :useHex="useHex"
          :filterCombos="filterCombos"
          :bettingInfo
          :noValue="item[htcItem.props.player].no_data"
          :asEmpty="false"
          :maximizible="false"
          :hasBlockers="false"
        >
          <template #title>
            <StudyReportsGroupItemTitle
              :item="item"
              class="htc_title_symbols clr-black"
              :flopGroup="flopGroup"
            />
          </template>
          <template #value>
            <span
              v-if="item.id === reportItemId && !viewProps.display_strategy"
              class="uppercase anim-fade-in"
              style="position: absolute; left: 1rem"
            >
              {{ htcItem.player.position }}
              <span style="font-size: 0.8em">
                {{ htcItem.key }}
              </span>
              <i
                v-if="htcItem.player.is_hero"
                class="mdi mdi-crown position-relative"
                style="top: 0.0875em"
              />
            </span>
          </template>
        </HandTableCell>
      </div>
    </div>
  </div>
</template>

<script>
import StudyReportsGroupItemTitle from '@/components/Study/StudyReportsGroupItemTitle'
import HandTableCell from '@/components/Study/HandTableCell'

export default {
  name: 'RepTurnCells',
  components: {
    HandTableCell,
    StudyReportsGroupItemTitle,
  },
  // mixins: [format_mix, float_mix, links_mix],
  props: {
    items: Array,
    // hero: Object,
    // opponent: Object,
    solution: { default: () => [] },
    isPreflop: Boolean,
    useHex: Boolean,
    grouping: String,
    filterCombos: Object,
    showBetsIn: String,
    bettingInfo: Object,
    reportItemId: String,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    viewProps: Object,
    hSpot: Object,
    street: String,
    mobile: Boolean,
    flopGroup: String,
  },
  data() {
    return {}
  },

  computed: {
    htcItems() {
      const vps = this.viewProps
      const res = [
        {
          visible: vps.display_strategy,
          key: 'strategy',
          props: {
            player: vps.heroRelPos,
            // hasLegend: false,
          },
        },
        {
          visible: vps.display_oop,
          player: vps.oop_player,
          key: 'oop',
          props: {
            player: 'oop',
            // hasLegend: false,
          },
        },
        {
          visible: vps.display_ip,
          player: vps.ip_player,
          key: 'ip',
          props: {
            player: 'ip',
            // hasLegend: false,
          },
        },
      ].filter(htc => htc.visible)
      // console.log(this.items)
      // console.log(res)
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.repcells {
  display: flex;
  border-radius: 4px;
  height: 50%;
  width: 100%;
  margin: auto;
  // margin: auto;4

  &_grid {
    --grid-rows: 4;
    --grid-columns: 13;

    display: grid;
    grid-template-rows: repeat(var(--grid-rows), 1fr);
    grid-template-columns: repeat(var(--grid-columns), 1fr);
    width: 100%;
    height: 100%;
    flex: 1 !important;
  }
  &_cell {
    flex: 1;
    outline: solid 1px var(--clr-black-1);
    position: relative;
    z-index: 1;
    cursor: pointer;
    &_empty {
      pointer-events: none;
      cursor: default;
    }
    --top: 0px;
    --left: 0px;
    --htc-value-size: clamp(1px, 1.25rem, 2.5vw);
    // --htc-value-size: 1.25rem;
    --item-radius: 0;
    &_item {
      position: absolute !important;
      height: 100%;
      width: 100%;
      top: var(--top);
      left: var(--left);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border-radius: var(--item-radius);
      --before-opacity: 0;
      &:hover {
        --before-opacity: 1;
      }
      &_cell {
        flex: 1;
        &:before {
          content: '';
          opacity: var(--before-opacity);
          // transgition: 0.15s;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          z-index: 1;
          background: rgba(0, 0, 0, 0.4);
        }
        &:nth-child(2) {
          border-top: 1px solid var(--clr-black-1);
        }
      }
    }
    &_active {
      z-index: 2;
      outline: solid 1px transparent;
      --htc-value-size: 1.75rem;
      .repcells_cell_item {
        --item-radius: 4px;
        --before-opacity: 0;
        height: var(--active-size-height);
        width: var(--active-size-width);
        transition: 0.15s;
        box-shadow:
          0px 0px 0px 4px var(--clr-primary),
          0px 0px 16px 0px rgba(0, 0, 0, 0.85);
      }
    }
  }

  --active-size-width: 150%;
  --active-size-height: 125%;
  .repcells_cell {
    &:first-child {
      --item-radius: 4px 0 0 4px;
    }
    &:last-child {
      --item-radius: 0 4px 4px 0;
    }
  }
  .repcells_cell_active {
    --left: -4px;
    --top: calc(-12.5% - 2px);
    &:first-child {
      --left: 4px;
    }
    &:last-child {
      --left: calc(-50% - 4px);
    }
  }
  &_swv_pairing {
    --active-size-width: 125%;
    --active-size-height: 125%;
    .repcells_cell_active {
      &:last-child {
        --left: calc(-25% - 2px);
      }
    }
  }

  &_swv_card_ranks {
    --active-size-width: 300%;
    --active-size-height: 125%;
    .repcells_cell_active {
      &:nth-last-child(2) {
        --left: calc(-100% - 2px);
      }
      &:last-child {
        --left: calc(-200% - 2px);
      }
    }
  }
  &_swv_turns {
    --active-size-width: 300%;
    --active-size-height: 150%;

    .repcells_cell {
      &:nth-child(n + 1):nth-child(-n + 13) {
        --item-radius: 0 4px 0 0;
      }
      &:nth-last-child(13) {
        --item-radius: 0 0 0 4px;
      }
      &:first-child {
        --item-radius: 4px 0 0 0 !important;
      }
      &:last-child {
        --item-radius: 0 0 4px 0;
      }
    }
    .repcells_cell_active {
      --left: -4px;
      &:nth-child(n + 1):nth-child(-n + 13) {
        --top: 4px;
      }
      &:nth-child(13n + 1) {
        --left: 4px;
      }
      &:nth-child(13n + 12) {
        --left: calc(-100% - 4px);
      }
      &:nth-child(13n + 13) {
        --left: calc(-200% - 4px);
      }
      &:nth-child(n + 40):nth-child(-n + 52) {
        --top: calc(-50% - 4px);
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .repcells {
    --active-size-width: 200%;
    .repcells_cell_active {
      &:last-child {
        --left: calc(-100% - 4px);
      }
    }

    &_swv_pairing {
      --active-size-width: 175%;
      .repcells_cell_active {
        &:last-child {
          --left: calc(-75% - 4px);
        }
      }
    }
    &_swv_card_ranks {
      --active-size-width: 600%;
      .repcells_cell_active {
        &:nth-last-child(5) {
          --left: calc(-100% - 2px);
        }
        &:nth-last-child(4) {
          --left: calc(-200% - 2px);
        }
        &:nth-last-child(3) {
          --left: calc(-300% - 2px);
        }
        &:nth-last-child(2) {
          --left: calc(-400% - 2px);
        }
        &:last-child {
          --left: calc(-500% - 4px);
        }
      }
    }
    &_swv_turns {
      --active-size-width: 600%;
      .repcells_cell_active {
        &:nth-child(n + 1):nth-child(-n + 13) {
          --top: 4px;
        }
        &:nth-child(13n + 1) {
          --left: 4px;
        }
        &:nth-child(13n + 9) {
          --left: calc(-100% - 4px);
        }
        &:nth-child(13n + 10) {
          --left: calc(-200% - 4px);
        }
        &:nth-child(13n + 11) {
          --left: calc(-300% - 4px);
        }
        &:nth-child(13n + 12) {
          --left: calc(-400% - 4px);
        }
        &:nth-child(13n + 13) {
          --left: calc(-500% - 4px);
        }
      }
    }
  }
}
</style>
